import React from 'react';
import { Heading, Icon } from '@printdeal/ui-library';
import clsx from 'clsx';
import NavigationLink from '../NavigationLink';
import type { Navigation } from '../../../types';

type MobileFeaturedNavigationProps = {
  navigation: Navigation;
  className?: string;
};

const MobileFeaturedNavigation = ({
  navigation,
  className,
}: MobileFeaturedNavigationProps) => {
  if (!navigation.items || navigation.items.length === 0) {
    return null;
  }

  return (
    <nav className={clsx('pd-flex pd-flex-col pd-gap-4', className)} aria-labelledby="featured-navigation-title">
      <Heading variant="display" as="span" size="3" id="featured-navigation-title">
        {navigation.title}
      </Heading>
      <ul className="pd-flex pd-flex-col pd-gap-3">
        {navigation.items.map((navigationItem) => (
          <li key={navigationItem.id}>
            <NavigationLink
              to={navigationItem.linkedEntry?.path}
              iconAfter={<Icon icon="chevron-right" className="pd-ml-auto" />}
              navigationType="featured"
              eventLabel={navigationItem.title}
              className="pd-w-full"
            >
              {navigationItem.title}
            </NavigationLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MobileFeaturedNavigation;
